import type { PxlIconName } from "@/common/components/U/Icon";

const [provideToast, useToast] = useSingleton<{
  error: (msg: string, title?: string, icon?: PxlIconName) => void;
  success: (msg: string, title?: string, icon?: PxlIconName) => void;
  warning: (msg: string, title?: string, icon?: PxlIconName) => void;
  info: (msg: string, title?: string, icon?: PxlIconName) => void;
}>();

export { provideToast, useToast };
